export const enum TipoNovedadEnum {
    PLAN_MANEJO = 'PLAN_MANEJO',
    EGRESO = 'EGRESO',
    PROGRAMACION = 'PROGRAMACION',
    INGRESO_PACIENTE = 'INGRESO_PACIENTE',
    CUIDADOR = 'CUIDADOR',
    CAMBIO_PISO = 'CAMBIO_PISO',
    DIAGNOSTICOS = 'DIAGNOSTICOS',
    EQUIPOS_BIOMEDICOS = 'EQUIPOS_BIOMEDICOS',
    CANCELAR_CITA = 'CANCELAR_CITA',
    APLICACION_CUIDADOR = 'APLICACION_CUIDADOR',
    FIJAR_CITA ='FIJAR_CITA',
    DESFIJAR_CITA = 'DESFIJAR_CITA',
    CITAS = 'CITAS',
    LABORATORIO = 'LABORATORIO',
    ALERTA_CITA = 'ALERTA_CITA',
    ALERTA_CITA_PROFESIONAL = 'ALERTA_CITA_PROFESIONAL',
    ASIGNAR_PROFESIONAL = 'ASIGNAR_PROFESIONAL',
    QUITAR_ASIGNACION = 'QUITAR_ASIGNACION',
    DIRECCION = 'DIRECCION',
    INFORMACION_PACIENTE = 'INFORMACION_PACIENTE',
    ENFERMERIA = 'ENFERMERIA',
    TERAPIAS_FISICAS = 'TERAPIAS_FISICAS',
    TERAPIAS_RESPIRATORIAS = 'TERAPIAS_RESPIRATORIAS',
    TERAPIAS_FONOAUDIOLOGIA = 'TERAPIAS_FONOAUDIOLOGIA',
    TERAPIA_OCUPACIONAL = 'TERAPIA_OCUPACIONAL',
    LABORATORIO_BACTERIOLOGO = 'LABORATORIO_BACTERIOLOGO',
    LABORATORIO_ENFERMERIA = 'LABORATORIO_ENFERMERIA',
    NUTRICIONISTA = 'NUTRICIONISTA',
    SICOLOGIA = 'SICOLOGIA',
    TRABAJO_SOCIAL = 'TRABAJO_SOCIAL',
    BACTERIOLOGO = 'BACTERIOLOGO',
    MEDICINA = 'MEDICINA',
    MEDICINA_CRONICOS = 'MEDICINA_CRONICOS',
    MEDICINA_PALEATIVOS = 'MEDICINA_PALEATIVOS',
    MEDICINA_AGUDOS = 'MEDICINA_AGUDOS',
    MEDICINA_AMI = 'MEDICINA_AMI',
    MEDICINA_PAS = 'MEDICINA_PAS',
    NUEVAAPLICACION_CUIDADOR = 'NUEVAAPLICACION_CUIDADOR',
    ACTIVACION = 'ACTIVACION',
    AGREGAR_CITA = 'AGREGAR_CITA',
    REPROGRAMAR_CITA = 'REPROGRAMAR_CITA',
    CLASIFICACION_PERMANENTES = 'CLASIFICACION_PERMANENTES',
}
